export const MAX_OWN_CONTRACT_SERVICES = 5;
